import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as clipboard from 'clipboard-polyfill';
import React from 'react';
import { match } from 'react-router-dom';

import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ActionsMenu } from '~src/spacesPlatform/components/ActionsMenu/ActionsMenu';

import { ConnectedApplicationInfoMapper } from '../models/ConnectedApplicationInfoMapper';
import { callGetConnectedApplicationEas } from '../serverApi/requests/GetConnectedApplicationEas';
import { IConnectedApplicationType } from '../serverApi/types/ConnectedApplicationType';
import { ConnectedApplicationsDetailsPageStyles } from '../styles/ConnectedApplicationsDetailsPageStyles';
import { ConnectedApplicationBackButton } from './ConnectedApplicationBackButton';


export type ConnectedApplicationEasDetailsSubspaceProps = { id: string };

// Weirdly just specifying the fact that our route type expects the ID to be defined is insufficient to actually have the ID in the type
// so we then need to specify that we do actually expect it in the "params" clause
export type ConnectedApplicationEasDetailsSubspaceRoutedProps = match<ConnectedApplicationEasDetailsSubspaceProps>;

export interface ConnectedApplicationEasDetailsSubspaceState {
  externalAuthorizationServer: IConnectedApplicationType;
  siteLuid: string;
}

export class ConnectedApplicationEasDetailsSubspace extends React.Component<ConnectedApplicationEasDetailsSubspaceRoutedProps, ConnectedApplicationEasDetailsSubspaceState>
{
  public constructor(props: ConnectedApplicationEasDetailsSubspaceRoutedProps) {
    super(props);
    this.state = ({
      externalAuthorizationServer: null,
      siteLuid: SessionSiteSelectors.siteLuid(getAppStore().getState())
    });
  }

  async componentDidMount() {
    const connectedApplicationId = this.props.params.id;
    if (!this.state.externalAuthorizationServer) {
      const result = await callGetConnectedApplicationEas(connectedApplicationId);
      let easApp = result.externalAuthorizationServer;
      easApp.name = easApp != null ? Messages.connectedApplicationsEasName() : '';
      this.setState({ externalAuthorizationServer: easApp });
    }
  }

  public render(): JSX.Element {
    return <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span className={ConnectedApplicationsDetailsPageStyles.backButtonSectionStyle}>
        <ConnectedApplicationBackButton />
      </span>
      <br></br>
      <span className={ConnectedApplicationsDetailsPageStyles.headerStyle} data-tb-test-id={ConnectedApplicationsDetailsPageStyles.connectedApplicationHeaderTestId}>
        <div style={{ paddingRight: 5 }}>{this.state.externalAuthorizationServer?.name}</div>
        <ActionsMenu
          targetItems={this.state.externalAuthorizationServer ? ConnectedApplicationInfoMapper.mapToExternalAuthorizationServerInfoType([this.state.externalAuthorizationServer]) : []}
          disabled={!this.state.externalAuthorizationServer}
          useIcon={true}
        />
      </span>
      <br></br>
      <span className={ConnectedApplicationsDetailsPageStyles.subHeaderStyle} data-tb-test-id={ConnectedApplicationsDetailsPageStyles.connectedApplicationSubHeaderTestId}>
        {Messages.connectedApplicationsStatus()}
        <strong style={{ paddingLeft: 5, paddingRight: 10 }}>{this.state.externalAuthorizationServer?.enabled ? Messages.connectedApplicationsEnabled() : Messages.connectedApplicationsDisabled()}</strong>
        {Messages.created()}
        <strong style={{ paddingLeft: 5, paddingRight: 10 }}>{this.state.externalAuthorizationServer?.createdAt && L10n.localizedDate(this.state.externalAuthorizationServer?.createdAt)}</strong>
        {Messages.connectedApplicationsTrustType()}
        <strong style={{ paddingLeft: 5, paddingRight: 10 }}>{Messages.connectedApplicationsOAuth()}</strong>
        {Messages.connectedApplicationsAuthorizationServer()}
        <strong style={{ paddingLeft: 5, paddingRight: 10 }}>{Messages.connectedApplicationsAuthorizationServerExternal()}</strong>
      </span>
      <table className={ConnectedApplicationsDetailsPageStyles.tableStyle}>
        <tbody>
          <tr>
            <td className={ConnectedApplicationsDetailsPageStyles.labelStyle}>
              {Messages.connectedApplicationsSiteLuid()}
            </td>
            <td className={ConnectedApplicationsDetailsPageStyles.easDetailsCell} data-tb-test-id={ConnectedApplicationsDetailsPageStyles.connectedApplicationSiteLuidTestId}>
              {this.state.siteLuid}
              <ButtonWidget buttonType={ButtonType.Outline} onClick={async () => await clipboard.writeText(this.state.siteLuid)}>
                {Messages.connectedApplicationsDetailsCopySiteLuid()}
              </ButtonWidget>
            </td>
          </tr>
          <tr>
            <td className={ConnectedApplicationsDetailsPageStyles.labelStyle}>
              {Messages.connectedApplicationsEasIssuerUrl()}
            </td>
            <td className={ConnectedApplicationsDetailsPageStyles.easDetailsCell} data-tb-test-id={ConnectedApplicationsDetailsPageStyles.connectedApplicationEasIssuerURLDetailsTestId}>
              {this.state.externalAuthorizationServer?.issuerUrl}
            </td>
          </tr>
          <tr>
            <td className={ConnectedApplicationsDetailsPageStyles.labelStyle}>
              {Messages.connectedApplicationsEasJWKSUri()}
            </td>
            <td className={ConnectedApplicationsDetailsPageStyles.easDetailsCell} data-tb-test-id={ConnectedApplicationsDetailsPageStyles.connectedApplicationEasJWKSURIDetailsTestId}>
              {this.state.externalAuthorizationServer?.jwksUri}
            </td>
          </tr>
        </tbody>
      </table>
    </div>;
  }
}